export const DefaultUrl = "https://www.google.com"